import { useEffect, useRef, useState } from 'react';
import { ReactZoomPanPinchRef } from 'react-zoom-pan-pinch';

const minimumThreshold = 1.1;
const maximumThreshold = 2;

export function useInitZoom() {
  const [panningDisabled, setPanningDisabled] = useState(true);
  const zoomRef = useRef<ReactZoomPanPinchRef>(null);

  useEffect(() => {
    if (!zoomRef.current) {
      return;
    }

    const instance = zoomRef.current.instance;
    const transformState = instance.transformState;
    const scale = transformState.scale ?? 0;

    if (scale < minimumThreshold) {
      zoomRef.current.resetTransform(300, 'easeOutQuint');
    }

    if (scale >= maximumThreshold) {
      zoomRef.current.setTransform(transformState.positionX, transformState.positionY, 2, 300, 'easeOutQuint');
    }
  }, [zoomRef.current?.instance?.transformState.scale]);

  const onZoomStop = (ref: ReactZoomPanPinchRef) => {
    if (ref.state.scale === 1) {
      setPanningDisabled(true);
    } else {
      setPanningDisabled(false);
    }
  };

  return { zoomRef, panningDisabled, onZoomStop };
}
